import { render } from "./Tenant.vue?vue&type=template&id=035562a4&ts=true"
import script from "./Tenant.vue?vue&type=script&lang=ts"
export * from "./Tenant.vue?vue&type=script&lang=ts"

import "./Tenant.vue?vue&type=style&index=0&id=035562a4&lang=css"

import exportComponent from "/Users/easowong/Documents/Codex/2026-10-04/referenced-chatgpt-conversation-this-is-an/work/lodash-20261025-213817-507f/frontend-candidate/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__